import PersonaPage from "./PersonaPage";
import { questionsColleague } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für einen Kollegen oder eine Kollegin?",
    a: "Anders als bei Familie ist hier oft der berufliche Rahmen der Ausgangspunkt — ein Projekt, eine Haltung, eine kleine Alltagsszene. Genau darin liegt die Würdigung: zu zeigen, was Kolleg:innen sehen und Familie nicht.",
  },
  {
    q: "Wie persönlich darf eine Rede im beruflichen Kontext werden?",
    a: "Persönlicher, als man denkt. Ein Zitat, das er oder sie oft gebraucht hat, eine kleine Geste in Sitzungen — genau das macht aus einer Trauerformel eine echte Würdigung.",
  },
  {
    q: "Wir waren nicht eng, aber lange Kollegen. Reicht das?",
    a: "Ja. Kolleg:innen tragen einen anderen Teil des Lebens — Werktage, Verlässlichkeit, gemeinsame Ziele. Genau darin liegt eine eigene Form der Nähe, die eine Rede verdient.",
  },
  {
    q: "Sollen wir das Unternehmen oder Team erwähnen?",
    a: "Ja, wenn Sie mögen. Sie können im Fragebogen den Kontext hinterlegen — wir binden ihn behutsam ein, ohne dass die Rede zum Nachruf wird.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für einen Freund", to: "/trauerrede-freund" },
  { label: "Trauerrede für einen Mann", to: "/trauerrede-mann" },
  { label: "Trauerrede für eine Frau", to: "/trauerrede-frau" },
];

export default function TrauerredeKollege() {
  return (
    <PersonaPage
      slug="trauerrede-kollege"
      metaTitle="Trauerrede für einen Kollegen schreiben — würdevoll & professionell | Oratiorede"
      metaDescription="Eine würdevolle Trauerrede für Kollegen oder Kolleginnen — persönlich, respektvoll, im richtigen beruflichen Ton. Sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Kollege · Kollegin"
      headline={
        <>
          Eine Trauerrede für einen Kollegen.
          <br />
          <span className="italic text-umber">Würdevoll. Präzise. Menschlich.</span>
        </>
      }
      intro="Kolleg:innen tragen einen anderen Teil unseres Lebens: die Werktage, die kleinen Verlässlichkeiten, die geteilten Aufgaben. Ein behutsamer erster Entwurf, der genau diesen Ton trifft — professionell, aber nie unpersönlich."
      heroImage="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80"
      heroImageAlt="Ein aufgeräumter Schreibtisch mit einer Vase im warmen Licht — Sinnbild einer Trauerrede für einen Kollegen"
      questions={questionsColleague}
      exampleQuote={
        <>
          „Ich weiß nicht, wie viele Male ich in siebzehn Jahren an seinem Schreibtisch gestanden
          habe. Er hatte diese ruhige Art, kurz zu überlegen, bevor er antwortete — und danach
          wusste man immer, was zu tun war. Er hat nicht laut geführt. Er hat sorgfältig gearbeitet.
          Und wer mit ihm gearbeitet hat, hat gelernt, dass genau das eine Form von Größe ist.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
